import { useTranslation } from "react-i18next";
import { Image, Mic, Paperclip, Send } from "lucide-react";
import { apiSend, getRoute } from "@services/axios";
import { useEffect, useState } from "react";
import userIcon from "@assets/user.png";

const FollowSheat = ({ bookingNumber, mode }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  const laod = async () => {
    const response = await apiSend(
      [
        getRoute("BOOKING_RETRIEVE"),
        bookingNumber,
        "follow",
        "up",
        "sheet",
      ].join("/"),
      "get"
    );
    if (response?.data?.result?.messageList) {
      setData(response.data.result.messageList);
    }
  };

  useEffect(() => {
    laod();
  }, []); // Empty array ensures it runs only once after mount

  return (
    <>
      <div className="border rounded-3 p-3 my-1 hv-60 overflow-auto">
        <PrinterMessage items={data} />
      </div>
      <SendingMessageForm
        t={t}
        bookingNumber={bookingNumber}
        setData={setData}
      />
    </>
  );
};

export default FollowSheat;

function PrinterMessage({ items }) {
  return (
    <>
      {items.map((msg, index) => (
        <div key={index} className="d-flex align-items-start my-4">
          <span>
            <img
              className="rounded-circle"
              src={userIcon}
              width={45}
              height={45}
            />
          </span>
          <span className="mx-2">
            <div className="fs-6">{msg.userName}</div>
            <p className="fw-light">{msg.createdAt}</p>
            <div className="d-flex flex-column align-items-start">
              <div
                className="my-2 bg-green text-white p-3 text-start"
                style={{ borderRadius: "0 20px 20px 20px" }}
              >
                {msg.message}
              </div>
            </div>
          </span>
        </div>
      ))}
    </>
  );
}
function SendingMessageForm({ t, bookingNumber, setData }) {
  const sendMassege = async () => {
    const payload = {
      message: document.getElementById("textMessage").value,
      is_customer_show: 1,
    };
    const response = await apiSend(
      [
        getRoute("BOOKING_RETRIEVE"),
        bookingNumber,
        "follow",
        "up",
        "sheet",
        "create",
      ].join("/"),
      "post",
      payload
    );

    document.getElementById("textMessage").value = "";
    if (response?.data?.result?.messageList) {
      setData(response?.data?.result?.messageList);
    }
  };
  useEffect(() => {
    const keyDownHandler = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        sendMassege();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, []);
  return (
    <div className="search-box d-flex justify-content-center">
      <div className="input-group col-sm-7  input-group-lg">
        <div className="input-group-prepend">
          <span className="input-group-text icon-left">
            <span className="d-flex">
              <span role="button" title={t("add_file")} className="mx-3">
                <Paperclip size={20} strokeWidth={1.5} />
              </span>
              <span role="button" title={t("add_image")} className="mx-3">
                <Image size={20} strokeWidth={1.5} />
              </span>
              <span role="button" title={t("save_vocal")} className="mx-3">
                <Mic size={20} strokeWidth={1.5} />
              </span>
            </span>
          </span>
        </div>
        <input type="text" className="form-control" id="textMessage" />
        <div className="input-group-append">
          <button className="input-group-text icon-right text-green">
            <Send strokeWidth={1.5} onClick={sendMassege} />
          </button>
        </div>
      </div>
    </div>
  );
}
